// Copyright (c) 2026 - Present. Hardfin, Inc. All rights reserved.
// Hardfin Confidential - Restricted
import { getChargeAuditEvents } from '@/audit/api/get-charge-audit-events';
import { AuditEventListItem } from '@/audit/components/audit-event-list-item';
import { Stack, Typography } from '@mui/material';
import { useSuspenseQuery } from '@tanstack/react-query';

interface Props {
  chargeKey: string;
}

/**
 * Suspends while fetching the audit events for a single charge and renders
 * them in reverse chronological order using the shared AuditEventListItem.
 */
export function ChargeAuditList(props: Props) {
  const { data } = useSuspenseQuery({
    queryKey: ['charge', props.chargeKey, 'audit'],
    queryFn: () => getChargeAuditEvents(props.chargeKey),
    retry: false,
  });

  if (data.events.length === 0) {
    return (
      <Typography variant="body2" color="text.secondary">
        No audit events recorded for this charge yet
      </Typography>
    );
  }

  return (
    <Stack spacing={2}>
      {data.events.map((event) => (
        <AuditEventListItem key={event.id} event={event} />
      ))}
    </Stack>
  );
}
